import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["baseUrl", "footerPage", "links", "copyrightText", "socialLinks", "footerText"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Footer/Footer.js",
  _this = this;
import React from 'react';
import Column from '../Column';
import Row from '../Row';
import { FooterGrid, FooterPagesRow, HeadingAnchor, FooterPage, FooterPageAnchor, FooterLinksRow, Divider, FlexGrid, Navigation, Anchor, Copyright, Social, SocialLink, SocialIcon, FooterText } from './style';
import { testIdProps } from '../../helpers';
var SocialLinks = function SocialLinks(_ref) {
  var socialLinks = _ref.socialLinks;
  return /*#__PURE__*/React.createElement(Social, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 3
    }
  }, socialLinks.map(function (item, key) {
    return /*#__PURE__*/React.createElement(SocialLink, {
      key: key,
      href: item.link,
      target: "_blank",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(SocialIcon, {
      src: item.icon,
      alt: item.text,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 9
      }
    }));
  }));
};
var Footer = function Footer(_ref2) {
  var baseUrl = _ref2.baseUrl,
    footerPage = _ref2.footerPage,
    links = _ref2.links,
    copyrightText = _ref2.copyrightText,
    socialLinks = _ref2.socialLinks,
    footerText = _ref2.footerText,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var calculatedHrefUrl = function calculatedHrefUrl(link) {
    if (link && (link.startsWith('http://') || link.startsWith('https://'))) {
      return link;
    }
    if (baseUrl) {
      return baseUrl + link;
    }
    return link;
  };
  return /*#__PURE__*/React.createElement(FooterGrid, _extends({}, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 5
    }
  }), footerPage && /*#__PURE__*/React.createElement(FooterPagesRow, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 9
    }
  }, footerPage.map(function (item, key) {
    return /*#__PURE__*/React.createElement(Column, {
      key: key,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(HeadingAnchor, {
      type: "link",
      href: calculatedHrefUrl(item.heading.src),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 17
      }
    }, item.heading.title), item.children && item.children.map(function (child, key) {
      return /*#__PURE__*/React.createElement(FooterPage, {
        sm: 12,
        key: key,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 23
        }
      }, /*#__PURE__*/React.createElement(FooterPageAnchor, {
        type: "link",
        href: calculatedHrefUrl(child.src),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 70,
          columnNumber: 25
        }
      }, child.title));
    }));
  })), /*#__PURE__*/React.createElement(FooterLinksRow, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 85,
      columnNumber: 7
    }
  }, links && /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Divider, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 88,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(FlexGrid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Navigation, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 90,
      columnNumber: 15
    }
  }, links.map(function (item, key) {
    return /*#__PURE__*/React.createElement(Anchor, {
      type: "link",
      key: key,
      href: calculatedHrefUrl(item.link),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 93,
        columnNumber: 21
      }
    }, item.text);
  })), /*#__PURE__*/React.createElement(Copyright, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 15
    }
  }, copyrightText), !copyrightText && socialLinks && /*#__PURE__*/React.createElement(SocialLinks, {
    socialLinks: socialLinks,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 105,
      columnNumber: 17
    }
  }))), /*#__PURE__*/React.createElement(Row, {
    style: {
      width: '100%'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 9
    }
  }, footerText && /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    sm: copyrightText && socialLinks ? 9 : 12,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FooterText, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 15
    }
  }, footerText)), copyrightText && socialLinks && /*#__PURE__*/React.createElement(Column, {
    xs: 12,
    sm: 3,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(SocialLinks, {
    socialLinks: socialLinks,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 15
    }
  })))));
};
export default Footer;